import { Text } from '@frameio/vapor';
import { IconCog } from '@frameio/vapor-icons';
import TEXT from './generated/TEXT/AccountSettingsNavItem';
import { UserProfileSettingsLink } from './UserProfileSettingsLink';

TEXT.DEFINE({
  /** Menu item label that opens the user/account settings page from the account avatar menu */
  settings: 'Settings',
});

export function AccountSettingsNavItem() {
  return (
    <UserProfileSettingsLink
      data-testid="primary-nav--my-profile-button"
      iconBefore={<IconCog />}
    >
      <Text color="body" variant="body">
        {TEXT.settings}
      </Text>
    </UserProfileSettingsLink>
  );
}
